import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

const ORDERED_GATE_TYPES = [
  'swing_gate',
  'double_leaf_gate',
  'sectional_gate',
  'roller_gate'
];

export default createSelector(
  constructionSelector,
  (construction) => {
    const gates = construction?.gates?.gates || [];
    const present = new Set(
      gates
        .map((g) => g?.type)
        .filter(Boolean)
    );

    // ✅ uporządkowana lista typów które występują w konfiguracji
    const gateTypesPresent = ORDERED_GATE_TYPES.filter((t) => present.has(t));

    return {
      loaded: construction.parameters_loaded,

      // INFO + selected (stare pola zostają dla kompatybilności)
      gates_color_info: construction.info?.gates_color,
      gates_color_selected: construction.selected?.gates_color,

      roof_color_info: construction.info?.roof_color,
      roof_color_selected: construction.selected?.roof_color,

      roofing_color_info: construction.info?.roofing_color,
      roofing_color_selected: construction.selected?.roofing_color,

      tooling_color_info: construction.info?.tooling_color,
      tooling_color_selected: construction.selected?.tooling_color,

      gutters_color_info: construction.info?.gutters_color,
      gutters_color_selected: construction.selected?.gutters_color,

      roof_tooling_color_info: construction.info?.roof_tooling_color,
      roof_tooling_color_selected: construction.selected?.roof_tooling_color,

      walls_color_info: construction.info?.walls_color,
      walls_color_selected: construction.selected?.walls_color,

      doors_front_color_info: construction.info?.doors_front_color,
      doors_front_color_selected: construction.selected?.doors_front_color,

      doors_back_color_info: construction.info?.doors_back_color,
      doors_back_color_selected: construction.selected?.doors_back_color,

      doors_left_color_info: construction.info?.doors_left_color,
      doors_left_color_selected: construction.selected?.doors_left_color,

      doors_right_color_info: construction.info?.doors_right_color,
      doors_right_color_selected: construction.selected?.doors_right_color,

      sheet_thickness_available: [...(construction.available?.sheet_thickness || [])],
      sheet_thickness_selected: construction.selected?.sheet_thickness,

      // ✅ dostępne kolory do modala
      available: {
        matt: construction.available?.matt || [],
        wooden: construction.available?.wooden || [],
        smooth: construction.available?.smooth || []
      },

      colors: construction.available?.colors || [],

      // ✅ typy bram obecne w konfiguracji
      gateTypesPresent,

      // ✅ wybory kolorów per typ bramy (Twoje nowe nazwy)
      gatesColorSelectedByType: {
        swing_gate: construction.selected?.gates_swing_color ?? null,
        double_leaf_gate: construction.selected?.gates_double_leaf_color ?? null,
        sectional_gate: construction.selected?.gates_sectional_color ?? null,
        roller_gate: construction.selected?.gates_roller_color ?? null
      }
    };
  }
);
